import styled from 'styled-components';


interface IBannerStyledProps {
    background?: string;
    textColor?: string;
}

export const BannerStyled = styled.div<IBannerStyledProps>`
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    width: 100%;
    background: ${({ background }) => background};
    color: ${({ textColor }) => textColor || 'var(--text-color-dark)'};
`;

interface IBannerContentStyledProps {
    backgroundImageSize?: string;
    backgroundImageUrl?: string;
}

export const BannerContentStyled = styled.div<IBannerContentStyledProps>`
    padding: 12px;
    background-image: ${({ backgroundImageUrl }) => `url("${backgroundImageUrl}")`};
    background-position: right center;
    background-repeat: no-repeat;
    background-size: ${({ backgroundImageSize }) => backgroundImageSize || 'auto 128px'};
    border-radius: 16px;
    overflow: hidden;
`;

export const BannerContainerStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
`;

export const BannerTitleStyled = styled.div`
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    max-width: 100%;
    padding-right: 16px;
`;

export const BannerDescriptionStyled = styled.div`
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    opacity: 0.6;
`;

export const BannerCloseWrapperStyled = styled.div`
    position: absolute;
    top: -6px;
    right: -6px;
    padding: 4px;
    color: var(--color-black);
`;
